import React, { useRef, useState } from "react";
import noImage from "../../assets/noimage.jpg";
import backArrow from "../../assets/go-back-ico.png"; // Add your back button image
import nextArrow from "../../assets/go-next-ico.png"; // Add your next button image

interface Slide {
  url: string;
}

interface ImageSliderProps {
  slides: Slide[] | null;
}

const slideStyles: React.CSSProperties = {
  width: "100%",
  height: "100%",
  borderRadius: "10px",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const rightArrowStyles: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  transform: "translate(0, -50%)",
  right: "32px",
  fontSize: "25px",
  color: "#fff",
  zIndex: 1,
  cursor: "pointer",
};

const leftArrowStyles: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  transform: "translate(0, -50%)",
  left: "32px",
  fontSize: "25px",
  color: "#fff",
  zIndex: 1,
  cursor: "pointer",
};

const sliderStyles: React.CSSProperties = {
  position: "relative",
  height: "100%",
};

const dotsContainerStyles: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
};

const dotStyle: React.CSSProperties = {
  margin: "0 3px",
  cursor: "pointer",
  fontSize: "20px",
  color: "rgba(85, 84, 95, 0.8)",
};

const currentDotStyle: React.CSSProperties = {
  margin: "0 3px",
  cursor: "pointer",
  fontSize: "20px",
  color: "white",
};

const fallbackImageUrl = noImage;

const RportIncidentsImageSlider: React.FC<ImageSliderProps> = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const touchStartX = useRef<number>(0);
  const touchEndX = useRef<number>(0);

  const goToPrevious = () => {
    if (!slides || slides.length === 0) return;
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    if (!slides || slides.length === 0) return;
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const goToSlide = (slideIndex: number) => {
    if (!slides || slides.length === 0) return;
    setCurrentIndex(slideIndex);
  };


  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.targetTouches[0].clientX;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      goToNext();
    }

    if (touchStartX.current - touchEndX.current < -50) {
      goToPrevious();
    }
  };

  const slideStylesWidthBackground: React.CSSProperties = {
    ...slideStyles,
    backgroundImage: `url(${slides && slides.length > 0 ? slides[currentIndex].url : fallbackImageUrl})`,
  };

  if (slides === null || (slides && slides.length === 0)) {
    return (
      <div style={sliderStyles}>
        <div style={slideStylesWidthBackground}></div>
      </div>
    );
  }

  return (
    <div style={sliderStyles}
    onTouchStart={handleTouchStart}
    onTouchMove={handleTouchMove}
    onTouchEnd={handleTouchEnd}>
      <div>
        <div onClick={goToPrevious} onTouchStart={goToPrevious} style={leftArrowStyles}>
        <img src={backArrow} alt="Back" style={{ width: "30%", height: "30%" }} /> 
        </div>
        <div onClick={goToNext} onTouchStart={goToNext} style={rightArrowStyles}>
        <img src={nextArrow} alt="Back" style={{ width: "30%", height: "30%" }} />
        </div>
  
      </div>
      <div style={slideStylesWidthBackground}></div>
      <div style={dotsContainerStyles}>
        {slides.map((slide, slideIndex) => (
          <div
            style={slideIndex === currentIndex ? currentDotStyle : dotStyle}
            key={slideIndex}
            onClick={() => goToSlide(slideIndex)}
            onTouchStart={() => goToSlide(slideIndex)}
          >
            ●
          </div>
        ))}
      </div>
    </div>
  );
};

export default RportIncidentsImageSlider;
